var map = {
	"./AIcontroller.js": 37928,
	"./AiResponseController.js": 73539,
	"./AvatarController.js": 3131,
	"./UIcontroller.js": 45035,
	"./databaseControllerOLD.js": 23984,
	"./dbController.js": 28337,
	"./fileController.js": 94253,
	"./index.js": 85931,
	"./speechRecController.js": 57497,
	"./traningController.js": 79808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26372;